module.exports = __webpack_public_path__ + "static/case_img2-3e9b4f7b4844f0c9efd8e980985de83b.png";